<template>
  <div>
    <header :class="['navbar hidden-sm-and-down', { 'navbar-solid': scrolled }]">
      <div class="container">
        <div class="home hidden-sm-and-down">
          <a href="/">
            <img v-if="$i18n.locale === 'zh'" src="../assets/common/logo.png" alt="Logo"
                 style="height: 3.5vw; margin-top: 0.5vw">
            <img v-else-if="$i18n.locale === 'en'" src="../assets/common/logo.png" alt="Logo"
                 style="height: 3.5vw; margin-top: 0.5vw">
          </a>
        </div>
        <div class="menus hidden-sm-and-down">
          <span class="title" @click="scrollToSection('#game')">GAME</span>
          <span class="title" @click="scrollToSection('#about')">ABOUT</span>
          <span class="title" @click="scrollToSection('#connect')">CONNECT</span>
        </div>
      </div>
    </header>
    <div :class="['header_mobile', { 'navbar-solid': scrolled }]">
      <div class="header_mobile2 hidden-sm-and-up">
        <div class="home">
          <a href="/">
            <img v-if="$i18n.locale === 'zh'" src="../assets/common/logo.png" alt="Logo"
                 style="height: 5vw; margin-top: 1vw">
            <img v-else-if="$i18n.locale === 'en'" src="../assets/common/logo.png" alt="Logo"
                 style="height: 5vw; margin-top: 1vw">
          </a>
        </div>
        <div class="menus">
          <span class="title" @click="scrollToSection('#game')">GAME</span>
          <span class="title" @click="scrollToSection('#about')">ABOUT</span>
          <span class="title" @click="scrollToSection('#connect')">CONNECT</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['isHome'], // 如果是主页的navbar，则添加透明滚动渐变效果
  data() {
    return {
      scrolled: false, // 是否有滚动
      language: 'zh',
      activeIndex: '' // 初始化选中项
    };
  },
  methods: {
    openNewWindow() {
      window.open('https://app.mokahr.com/su/coxikq');
    },
    handleScroll() {
      this.scrolled = window.scrollY > 0; // 滚动事件的回调
      if (window.scrollY === 0) {
        this.activeIndex = ''; // 当滚动到顶部时清除选中状态
      }
    },
    scrollToSection(section) {
      this.activeIndex = section; // 更新选中状态
      // this.$router.push({ hash: section }); // 使用 Vue Router 跳转到锚点
      this.smoothScrollTo(section); // 平滑滚动到指定位置
    },
    smoothScrollTo(section) {
      const element = document.querySelector(section);
      // if (element) {
      //   element.scrollIntoView(); // 平滑滚动
      // }
      const rect = element.getBoundingClientRect()
      const offsetTop = rect.top + window.scrollY;
      // 手动滚动到元素位置，并留出一些空间（例如 80px）
      const extraOffset = 110; // 留出 80px 的空间
      window.scrollTo({
        top: offsetTop - extraOffset,
        behavior: 'smooth'
      });
    },
    handleCommand(command) { // 小屏状态时的下来菜单点击回调
      this.$router.push(command);
    },
    //切换中英文
    handleChangeLanguage(type) {
      this.language = type;
      this.$i18n.locale = type;
      window.localStorage.setItem('so_lang', type);
      this.$router.push('/');
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll); // 监听滚动事件
  },
};
</script>

<style lang="less" scoped>
@import 'element-ui/lib/theme-chalk/display.css';
@import url('../assets/style/colors.less');

// 菜单栏
.navbar {
  height: 4.2vw;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  line-height: 90px;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.6); /* 半透明背景 */

  .home {
    float: left;
  }

  .menus {
    float: right;
    margin-right: 10vw;
    .title{
      height: 100%;
      width: 6vw;
      display: inline-block;
      text-align: center;
      //加粗
      font-weight: 600;
      color: #E23E3C;
    }
  }

  .lang {
    position: absolute;
    right: 0;
    top: 0;

    .el-menu {
      margin-right: 0vw;
    }

    .el-menu-item {
      width: 11vw;
    }

    .el-submenu {
      width: 11vw;
    }
  }

  //&.navbar-solid { /* 当滚动时改变背景颜色 */
  //  background-color: white;
  //}
}

.header_mobile {
  //background-color: rgba(0, 0, 0, 0.6); /* 半透明背景 */
  background-color: white; /* 半透明背景 */
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  .header_mobile2 {
    display: flex;
    width: 100%;
    align-items: center; /* 垂直居中对齐 */
    justify-content: space-between; /* 水平两端对齐 */
    padding: 10px; /* 添加一些内边距，防止内容过于靠近边缘 */
  }

  .home {
    text-align: left;
    img {
      height: 7.5vw;
    }
  }

  .menus .title {
    cursor: pointer; /* 鼠标悬停时显示指针 */
    font-weight: bold; /* 可选：加粗文字 */
    margin-right: 20px;
    font-size: 11px;
    color: #E23E3C;
  }
  //&.navbar-solid { /* 当滚动时改变背景颜色 */
  //  background-color: white;
  //}
}
</style>
